import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72247462"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "node-wrapper" }
const _hoisted_2 = { class: "node-content" }
const _hoisted_3 = {
  key: 0,
  class: "error"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "warning", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "node-description" }
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.name), 1),
      (_ctx.description)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.description), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}